import React from "react";
import { object, bool, func } from "prop-types";
import { STATIC_KEYWORDS } from "../../../constants";

import { UpArrow, DownArrow } from "../../atoms";
import { useDeviceType } from "../../customHooks/useDeviceType";

import "./read-more.m.css";

const charLimits = {
  desktop: 180,
  tablet: 160,
  mobile: 60,
};

const ReadMoreToggle = ({ textElement, isExpanded, onClick }) => {
  const deviceType = useDeviceType();
  const charLimit = charLimits[deviceType];

  return (
    <>
      {textElement?.text?.length > charLimit && (
        <button
          styleName={`read-more-btn-toggle ${isExpanded ? STATIC_KEYWORDS.EXPANDED : ""}`}
          className={`read-more-btn-toggle ${isExpanded ? STATIC_KEYWORDS.EXPANDED : ""}`}
          onClick={onClick}
        >
          {!isExpanded ? `${STATIC_KEYWORDS.READ_MORE}` : STATIC_KEYWORDS.READ_LESS}
          {isExpanded ? <UpArrow /> : <DownArrow />}
        </button>
      )}
    </>
  );
};

ReadMoreToggle.propTypes = {
  textElement: object,
  isExpanded: bool,
  onClick: func,
};

export default ReadMoreToggle;
